// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0ad5c625","806":"6d8fc042"}[chunkId] + ".chunk.js";
};